import React from "react";
import { Fragment } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import PrivateRouth from "./context/PrivateRouth";
import SignUp from "./pages/SignUp";
import MyProfile from "./pages/MyProfile";
import AllUsers from "./pages/AllUsers";
import Home from "./pages/Home";
import Header from "./components/Header";
import "./App.css";
import Makhabrash from "./components/Makhabrash";
import Footer from "./components/Footer";
import AllusersSearch from "./pages/AllusersSearch";
import ContactUsPage from "./pages/ContactUsPage";
const LayoutWithHeader = ({ children }) => {
  return (
    <Fragment>
      <Header />
      {children}
    </Fragment>
  );
};

function App() {
  return (
    <div className="App">
      <Makhabrash />
      <Router>
        <Fragment>
          <Routes>
            <Route
              path="/"
              element={
                <LayoutWithHeader>
                  <Home />
                </LayoutWithHeader>
              }
            />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUp />} />
            <Route
              path="/contactUsPage"
              element={
                <LayoutWithHeader>
                  <ContactUsPage />
                </LayoutWithHeader>
              }
            />

            <Route
              path="/allusers"
              element={
                <LayoutWithHeader>
                  <AllUsers />
                </LayoutWithHeader>
              }
            />
            <Route
              path="/allusersSearch"
              element={
                <LayoutWithHeader>
                  <AllusersSearch />
                </LayoutWithHeader>
              }
            />
            <Route
              path="/myprofile/:id"
              element={
                <LayoutWithHeader>
                  <MyProfile />
                </LayoutWithHeader>
              }
            />
          </Routes>
        </Fragment>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
